<script lang="ts">
  import { shouldShowTabCount } from './tab-count';

  interface Props {
    /** 表示件数。0 件・未取得 (null) はバッジ自体を描画しない。 */
    count: number | null;
    testId?: string;
  }

  let { count, testId }: Props = $props();
</script>

<!--
  上位タブの件数バッジ (spec 20260613-tab-counts-and-review-badges PR1)。
  中立色のみ (警告色にしない)。読み上げはタブボタン側の aria-label
  (tabCountAriaLabel) が担うため、バッジ自体は aria-hidden。
-->
{#if shouldShowTabCount(count)}
  <span class="tab-count" aria-hidden="true" data-testid={testId}>{count}</span>
{/if}

<style>
  .tab-count {
    display: inline-block;
    min-width: 18px;
    margin-left: 6px;
    padding: 1px 6px;
    border-radius: 999px;
    background: #e5e7eb;
    color: #374151;
    font-size: 0.6875rem;
    font-weight: 600;
    line-height: 1.4;
    text-align: center;
  }
</style>
